// Returns the midpoint yaw between start and end, handling ±180° wrap-around.
// e.g. start=150, end=-150 → 180 (not 0)
export function midYaw(start, end) {
  if (end >= start) {
    return Math.round((start + end) / 2);
  }
  // wrap-around case: start is near +180, end is near -180
  let mid = (start + end + 360) / 2;
  if (mid > 180) mid -= 360;
  return Math.round(mid);
}

export function cosineSim(vecA = [], vecB = []) {
  let dot = 0, magA = 0, magB = 0;
  const len = Math.min(vecA.length, vecB.length);
  for (let i = 0; i < len; i++) {
    const a = vecA[i] || 0;
    const b = vecB[i] || 0;
    dot += a * b;
    magA += a * a;
    magB += b * b;
  }
  if (!magA || !magB) return 0;
  return dot / (Math.sqrt(magA) * Math.sqrt(magB) + 1e-10);
}
